export { default } from './UnscoredAlternativeProductsTable'
